import { Check, CheckCheck, Clock, AlertCircle, RotateCw } from "lucide-react";

// WhatsApp-style status of an OWN message. Only shows states recorded by the server:
// sent = stored, delivered = recipient's app synced it, read = recipient opened the conversation.
export function MsgTicks({ m, tr, onRetry }) {
  const base = "mt-0.5 flex items-center justify-end gap-0.5 text-[9px] opacity-80";
  if (m.status === "sending") return <div className={base} data-testid="msg-sending"><Clock className="h-3 w-3" /> {tr("Envoi…", "Sending…")}</div>;
  if (m.status === "failed") {
    return (
      <button type="button" onClick={() => onRetry(m)} className={`${base} w-full font-semibold text-red-200`} data-testid="msg-failed-retry">
        <AlertCircle className="h-3 w-3" /> {tr("Échec — réessayer", "Failed — retry")} <RotateCw className="h-3 w-3" />
      </button>
    );
  }
  if (m.read_at) return <div className={`${base} text-sky-300`} data-testid={`read-${m.id}`}><CheckCheck className="h-3.5 w-3.5" /> {tr("Lu", "Read")}</div>;
  if (m.delivered_at) return <div className={base} data-testid={`delivered-${m.id}`}><CheckCheck className="h-3.5 w-3.5" /> {tr("Distribué", "Delivered")}</div>;
  return <div className={base} data-testid={`sent-${m.id}`}><Check className="h-3.5 w-3.5" /> {tr("Envoyé", "Sent")}</div>;
}

export const newClientMsgId = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

// Send with a stable client id so retries never create duplicates server-side.
export async function sendWithRetryId(post, pending, setPending) {
  setPending((p) => [...p.filter((x) => x.cid !== pending.cid), { ...pending, status: "sending" }]);
  try {
    const res = await post(pending);
    setPending((p) => p.filter((x) => x.cid !== pending.cid));
    return res;
  } catch (e) {
    setPending((p) => p.map((x) => (x.cid === pending.cid ? { ...x, status: "failed" } : x)));
    throw e;
  }
}
